<template>
  <div class="passwordMng">
    <!-- 返回 -->
		<el-button type="primary" icon="el-icon-back" circle class="back-icon" @click="back"></el-button>
    <el-card class="l-card">
      <h2 class="l-title">{{$t('lang.lab_modifyPwd')}}</h2>
      <!-- 表格 -->
      <el-form :model="form" label-position="top" :rules="rules" ref="form" class="l-accountNumber-box" label-width="140px">
        <!-- 当前账号 -->
        <el-form-item prop="accountNumber" :label="$t('lang.lab_account')">
          <el-input  v-model="form.accountNumber" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_account')" disabled></el-input>
        </el-form-item>
        <!-- 旧密码 -->
        <el-form-item prop="password" :label="$t('lang.lab_oldPwd')">
          <el-input type="password" v-model="form.password" maxlength="16" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_oldPwd')"></el-input>
        </el-form-item>
        <!-- 新密码 -->
        <el-form-item prop="newPwd" :label="$t('lang.lab_newPwd')">
          <el-input type="password" v-model="form.newPwd" maxlength="16" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_newPwd')"></el-input>
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item prop="newDoublePwd" :label="$t('lang.lab_comfirmPwd')">
          <el-input type="password" v-model="form.newDoublePwd" maxlength="16" :placeholder="$t('lang.pla_pleaseInputAgain')"></el-input>
        </el-form-item>
        <el-button type="primary" class="l-btn" @click="change('form')">{{$t('lang.lab_changePwd')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:passwordMng
 *@Description:修改密码
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-23
 */
export default {
  name: 'passwordMng',
  components: {},
  data() {
    // 密码规则
    var passwordValue = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
    // 原密码
    var passwordCheck = (rule, value, callback) => {
      if (this.form.password === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_oldPwd')))
      } else {
        callback()
      }
    }
    // 新密码
    var newPwdCheck = (rule, value, callback) => {
      if (this.form.newPwd === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_newPwd')))
      } else if (!passwordValue.test(value)) {
        this.$message.error(this.$i18n.t('lang.warning_passwordRule'))
        callback(new Error(this.$i18n.t('lang.warning_passwordNotOK')))
      } else {
        callback()
      }
    }
    // 确认密码
    var newDoublePwdCheck = (rule, value, callback) => {
      if (this.form.newDoublePwd === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_comfirmPwd')))
      } else if (!passwordValue.test(value)) {
        this.$message.error(this.$i18n.t('lang.warning_passwordRule'))
        callback(new Error(this.$i18n.t('lang.warning_passwordNotOK')))
      } else {
        callback()
      }
    }
    return {
      form: {
        accountNumber: '',
        password: '',
        newPwd: '',
        newDoublePwd: ''
      },
      rules: {
        accountNumber: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_account'), trigger: 'blur' }],
        password: [{ required: true, validator: passwordCheck, trigger: 'blur' }],
        newPwd: [{ required: true, validator: newPwdCheck, trigger: 'blur' }],
        newDoublePwd: [{ required: true, validator: newDoublePwdCheck, trigger: 'blur' }],
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 修改密码
    change(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.newPwd !== this.form.newDoublePwd) {
            console.log('warning_passwordNotSame')
            this.$message.error(this.$i18n.t('lang.warning_passwordNotSame'))
            return
          }
          let params = {
            accountNumber: this.form.accountNumber.toString(),
            password: this.form.password,
            newPwd: this.form.newPwd,
            newDoublePwd: this.form.newDoublePwd            
          }
          this.$patch('/user/password', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_changePwdSuccess')
                })
                setTimeout(() => {
                  localStorage.clear() // 清理localStorage里面的所有数据
                  this.$router.push({ name: 'login' })
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 返回
    back() {
      window.history.go(-1)
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let key = window.event.keyCode
        if (key === 13) {
          this.login()
        }
      }
    },
    unKeyupSubmit() {
      document.onkeydown = e => {
        let key = window.event.keyCode
        if (key === 13) {}
      }
    },
  },
  created() {
    this.form.accountNumber = localStorage.getItem('accountNumber')
  },
  mounted() {},
  destroyed() {
  }
}
</script>

<style lang='scss'>
.passwordMng {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
	.back-icon {
		position: absolute;
		left: 20px;
		top: 20px;
		font-size: 20px;
	}

  .l-card {
    width: 500px;
    height: 650px;
    position: relative;
		background-color: white;
		border: 1px solid #f3f7fd;
		box-shadow: 10px 10px 5px #f3f7fd;

    .el-form--label-top .el-form-item__label {
      padding: 0!important;
    }
    .el-form-item__error {
      padding-top: 5px !important;
    }
    .l-title {
			margin-top: 40px;
			text-align: center;
    }
    .l-accountNumber-box {
      margin: 10px 40px;
      text-align: left;
    }
    .l-btn {
      margin-top: 40px;
      position: absolute;
      bottom: 30px;
      width: calc(100% - 80px);
      left: 40px;
    }
  }
}
</style>
